jQuery_T4NT(document).ready(function ($) {
  /**
   *   Sort displaying of collection, sold out product to the last
   *   Only for Carousel layout
   *   Remove dot from list item
   *   Added by Aslan
   */

  // Iterate through product items in the carousel slider
  $(".t4s-product.t4s-col-item.is-t4s-pr-created").each(function () {
    const productOptions = JSON.parse($(this).attr("data-product-options"));
    if (!productOptions["available"]) {
      $(this).css("order", "999");
    }
  });

  // remove dot on list item
  $("ul").append(`
  <style>
    ul:after {
      list-style: none !important;
    }
  </style>
`);

  /**
   *  Variant selection changed
   *  data-variant-toggle="{{variant.id}}"
   */
  $(document).on("variant:changed", function (evt) {
    // console.log( evt.currentVariant );
    // $('[data-variant-toggle]').hide(0);
    // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  });

  $(document).on(
    "click",
    ".custom-variant-size-selector-container [data-dropdown-item]",
    function () {
      var variantId = $(this).data("variant-id");
      var variantPrice = $(this).data("variant-price");
      var variantCompareAtPrice = $(this).data("variant-compare-at-price");
      var onSale = $(this).data("variant-on-sale");
      console.log(
        `variantPrice: ${variantPrice}, variantCompareAtPrice: ${variantCompareAtPrice}, onSale: ${onSale}`
      );

      var priceHtml = T4SThemeSP.Currency.formatMoney(variantPrice);
      var compareAtPriceHtml = T4SThemeSP.Currency.formatMoney(
        variantCompareAtPrice
      );
      var priceContainerHtml = priceHtml;
      if (onSale) {
        priceContainerHtml = `
            <del>${compareAtPriceHtml}</del>
            <ins>${priceHtml}</ins>
            `;
      }

      $(this)
        .closest(".t4s-product-info")
        .find(".t4s-product-price")
        .html(priceContainerHtml);
      $(this)
        .closest(".custom-variant-size-selector-container")
        .siblings(".custom-atc-for-size")
        .attr("data-variant-id", variantId);
    }
  );

  $(document).on(
    "click",
    ".t4s-product.t4s_observered .custom-variant-wrapper button[data-dropdown-open]",
    function () {
      console.log("Hide overlay ...");
      for (let overlayElement of document.querySelectorAll(
        ".t4s-close-overlay"
      )) {
        overlayElement.style.visibility = "hidden";
      }
    }
  );

  //  $('[data-dropdown-item].is-selected').each(function(){
  //   var variantId = $(this).data("variant-id");
  //   var variantPrice = $(this).data("variant-price");
  //   var variantCompareAtPrice = $(this).data("variant-compare-at-price");
  //   var onSale = $(this).data("variant-on-sale");
  //   // console.log(
  //   //   `variantPrice: ${variantPrice}, variantCompareAtPrice: ${variantCompareAtPrice}, onSale: ${onSale}`
  //   // );

  //   var priceHtml = T4SThemeSP.Currency.formatMoney(variantPrice);
  //   var compareAtPriceHtml = T4SThemeSP.Currency.formatMoney(
  //     variantCompareAtPrice
  //   );
  //   var priceContainerHtml = priceHtml;
  //   if (onSale) {
  //     priceContainerHtml = `
  //         <del>${compareAtPriceHtml}</del>
  //         <ins>${priceHtml}</ins>
  //         `;
  //   }

  //   $(this)
  //     .closest(".t4s-product-info")
  //     .find(".t4s-product-price")
  //     .html(priceContainerHtml);
  //   $(this)
  //     .closest(".custom-variant-size-selector-container")
  //     .siblings(".custom-atc-for-size")
  //     .attr("data-variant-id", variantId);
  // })
  
});



class Wakate extends HTMLElement{
  constructor(){
    super();
    this.item_active = this.querySelector('[data-dropdown-item].is-selected');
    if(!this.item_active) return;
    
  }
  connectedCallback(){
    this.init();
  }
  init(){
    var variantId = this.item_active.getAttribute("data-variant-id");
    var variantPrice = this.item_active.getAttribute("data-variant-price");
    var variantCompareAtPrice = this.item_active.getAttribute("data-variant-compare-at-price");
    var onSale = JSON.parse(this.item_active.getAttribute("data-variant-on-sale"));
    // console.log(
    //   `variantPrice: ${variantPrice}, variantCompareAtPrice: ${variantCompareAtPrice}, onSale: ${onSale}`
    // );

    var priceHtml = T4SThemeSP.Currency.formatMoney(variantPrice);
    var compareAtPriceHtml = T4SThemeSP.Currency.formatMoney(
      variantCompareAtPrice
    );
    var priceContainerHtml = priceHtml;
    if (onSale) {
      priceContainerHtml = `
          <del>${compareAtPriceHtml}</del>
          <ins>${priceHtml}</ins>
          `;
    }

    this.item_active
      .closest(".t4s-product-info")
      .querySelector(".t4s-product-price")
      .innerHTML=priceContainerHtml;
    this.item_active
      .closest(".custom-variant-wrapper")
      .querySelector('[data-variant-id]').setAttribute("data-variant-id", variantId);
  }
}
customElements.define('lxc-wakate', Wakate);